import {handleActions} from 'redux-actions';
import actions from './profile.actions';
import {sessionActions} from '../user';

const reducer = handleActions(
	{
		[actions.profileLoading]: (state, {payload}) => null,
		[actions.profileLoaded]: (state, {payload}) => ({...payload}),
		[actions.profileUnloaded]: (state, {payload}) => null,
		[actions.profileAffiliationsLoaded]: (state, {payload}) => ({
			...state,
			communities: [...payload]
		}),
		[actions.profileUpdateName]: (state, {payload}) => ({
			...state,
			user: {
				...state.user,
				name: payload
			},
			editingField: null
		}),
		[actions.profileUpdateProviderField]: (state, {payload}) => ({
			...state,
			...payload,
			user: payload.user
				? {
						...(state.user || {}),
						...payload.user
				  }
				: state.user,
			profile: payload.profile
				? {
						...(state.profile || {}),
						...payload.profile
				  }
				: state.profile
		}),
		[actions.profileUpdateAbout]: (state, {payload}) => ({
			...state,
			profile: {
				...state.profile,
				about: payload
			},
			editingField: null
		}),
		[actions.profileUpdateBrief]: (state, {payload}) => ({
			...state,
			profile: {
				...state.profile,
				brief: payload
			},
			editingField: null
		}),
		[actions.profileDragOverBackgroundImage]: state => ({
			...state,
			draggingOverBackgroundImage: true
		}),
		[actions.profileDragOutBackgroundImage]: state => ({
			...state,
			draggingOverBackgroundImage: null
		}),
		[actions.profileUpdatingBackgroundImage]: (state, {payload}) => ({
			...state,
			updatingBackgroundImage: {
				preview: payload,
				progress: 0
			}
		}),
		[actions.profileUpdatingBackgroundImageProgress]: (state, {payload}) => ({
			...state,
			updatingBackgroundImage: {
				...state.updatingBackgroundImage,
				progress: payload
			}
		}),
		[actions.profileUpdateBackgroundImage]: (state, {payload}) => ({
			...state,
			profile: {
				...state.profile,
				backgroundImage: payload
			},
			updatingBackgroundImage: null,
			editingField: null
		}),
		[actions.profileDragOverAvatarImage]: state => ({
			...state,
			draggingOverAvatarImage: true
		}),
		[actions.profileDragOutAvatarImage]: state => ({
			...state,
			draggingOverAvatarImage: null
		}),
		[actions.profileUpdatingAvatarImage]: (state, {payload}) => ({
			...state,
			updatingAvatarImage: {
				preview: payload,
				progress: 0
			}
		}),
		[actions.profileUpdatingAvatarImageProgress]: (state, {payload}) =>
			state && {
				...state,
				updatingAvatarImage: {
					...state.updatingAvatarImage,
					progress: payload
				}
			},
		[actions.profileUpdateAvatarImage]: (state, {payload}) => ({
			...state,
			profile: {
				...state.profile,
				avatarImage: payload
			},
			updatingAvatarImage: null,
			editingField: null
		}),
		[actions.profileDeleteImage]: (state, {payload}) => ({
			...state,
			profile: {
				...state.profile,
				images: state.profile.images.filter(image => image.image !== payload)
			},
			editingField: null
		}),
		[actions.profileAddingProfileImage]: (state, {payload}) => ({
			...state,
			addingProfileImage: {
				preview: payload,
				progress: 0
			},
			editingField: null
		}),
		[actions.profileAddingProfileImageProgress]: (state, {payload}) =>
			state && {
				...state,
				addingProfileImage: {
					...state.addingProfileImage,
					progress: payload
				},
				editingField: null
			},
		[actions.profileAddedProfileImage]: (state, {payload}) =>
			state && {
				...state,
				profile: {
					...state.profile,
					images: [payload].concat(state.profile.images)
				},
				addingProfileImage: null,
				editingField: null
			},
		[actions.profileDragOverProfileImage]: state => ({
			...state,
			draggingOverProfileImage: true
		}),
		[actions.profileDragOutProfileImage]: state => ({
			...state,
			draggingOverProfileImage: null
		}),
		[actions.profileUpdateProfession]: (state, {payload}) => ({
			...state,
			profession: payload,
			editingField: null
		}),
		[actions.profileUpdateCategory]: (state, {payload}) => ({
			...state,
			category: payload,
			editingField: null
		}),
		[actions.profileUpdateLocation]: (state, {payload}) => ({
			...state,
			user: {
				...state.user,
				location: {
					...payload
				}
			},
			editingField: null
		}),
		[actions.profileEditContacts]: state => ({
			...state,
			editingContacts: [...state.user.contacts] // Copy contacts into a separate editing area
		}),
		[actions.profileChangeEditContacts]: (state, {payload: {type, detail}}) => {
			let found = false;
			let editingContacts = state
				? state.editingContacts.map(contact => {
						if (contact.type === type) {
							found = true;
							return {type, detail}; // Return new contact object
						} else {
							return contact;
						}
				  })
				: [];

			if (!found) {
				// If new, add it to the list
				editingContacts = editingContacts.concat({type, detail});
			}

			return {
				...state,
				editingContacts
			};
		},
		[actions.profileCommitContacts]: (state, {payload}) => ({
			...state,
			user: {
				...state.user,
				contacts: [...payload]
			},
			editingContacts: null
		}),
		[actions.profileEditingField]: (state, {payload}) => ({
			...state,
			editingField: payload === state.editingField ? null : payload // Toggle if already editing, otherwise switch
		}),
		[actions.profileFavouritesLoaded]: (state, {payload}) => ({
			...state,
			favourites: [...payload]
		}),
		[actions.profileHelperSkip]: (state, {payload}) => ({
			...state,
			helperSkipped: state.helperSkipped ? [...state.helperSkipped, payload] : [payload]
		}),
		[actions.profileHelperClearSkips]: (state, {payload}) => ({
			...state,
			helperSkipped: []
		}),
		[actions.profileAddFavouritedCount]: state => ({
			...state,
			favouritedCount: (state.favouritedCount || 0) + 1
		}),
		[actions.profileSubtractFavouritedCount]: state => ({
			...state,
			favouritedCount: Math.max((state.favouritedCount || 0) - 1, 0)
		}),
		[actions.profileToggleYouTubePanel]: state => ({
			...state,
			youTubePanelShown: !state.youTubePanelShown
		}),
		[actions.profileUpdateEmailUnsub]: (state, {payload}) => ({
			...state,
			user: {
				...state.user,
				unsubbedFromEmail: payload
			}
		}),

		// If current session user is viewing their own profile, they can change subscription in the welcome popup
		[sessionActions.sessionUserWelcomed]: (state, {payload}) => {
			if (!state || payload.uuid !== state.uuid) {
				return state;
			} else {
				return {
					...state,
					subscriptionLevel: payload.subscriptionLevel,
					user: {
						...state.user,
						welcomed: true
					}
				};
			}
		},
		[actions.providerSetImgs]: (state, {payload}) => ({
			...state,
			profile: {
				...state.profile,
				images: payload
			}
		})
	},
	null
);

export default reducer;



// WEBPACK FOOTER //
// ./src/profile/profile.reducer.js